import { EnvelopeIcon, QuestionMarkCircleIcon } from "@heroicons/react/16/solid"

export const SupportPage = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center">
          <a href="/" className="flex items-center">
            <img src="/horizontal-1.png" alt="Vkonekte" className="h-32 w-auto" />
          </a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        {/* English */}
        <section className="mb-16">
          <h1 className="text-4xl font-extrabold text-gray-900 mb-2">Support</h1>
          <p className="text-lg text-gray-500 mb-12">
            We're here to help. Reach out to us through any of the channels below.
          </p>

          <div className="grid gap-6 sm:grid-cols-2 mb-12">
            <div className="flex flex-col items-start gap-3 p-6 rounded-2xl border border-gray-100 bg-gray-50">
              <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-blue-100">
                <EnvelopeIcon className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <p className="font-semibold text-gray-900">Email</p>
                <a href="mailto:vkonekte.official@gmail.com" className="text-sm text-blue-600 hover:underline">
                  vkonekte.official@gmail.com
                </a>
              </div>
            </div>

            <div className="flex flex-col items-start gap-3 p-6 rounded-2xl border border-gray-100 bg-gray-50">
              <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-blue-100">
                <QuestionMarkCircleIcon className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <p className="font-semibold text-gray-900">Response time</p>
                <p className="text-sm text-gray-500">Within 24 hours</p>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-gray-900">Frequently Asked Questions</h2>

            <div className="space-y-4">
              <details className="group border border-gray-100 rounded-2xl p-5 open:bg-blue-50/30">
                <summary className="font-semibold text-gray-900 cursor-pointer list-none flex items-center justify-between">
                  How do I access my purchased courses?
                  <span className="text-gray-400 group-open:rotate-180 transition-transform">↓</span>
                </summary>
                <p className="mt-3 text-gray-600 text-sm leading-relaxed">
                  After purchase, log in to your account and navigate to "My Courses". All purchased
                  courses will appear there automatically.
                </p>
              </details>

              <details className="group border border-gray-100 rounded-2xl p-5 open:bg-blue-50/30">
                <summary className="font-semibold text-gray-900 cursor-pointer list-none flex items-center justify-between">
                  Can I get a refund?
                  <span className="text-gray-400 group-open:rotate-180 transition-transform">↓</span>
                </summary>
                <p className="mt-3 text-gray-600 text-sm leading-relaxed">
                  Refunds are available within 7 days of purchase if course content has not been
                  accessed. Please contact vkonekte.official@gmail.com with your order details.
                </p>
              </details>

              <details className="group border border-gray-100 rounded-2xl p-5 open:bg-blue-50/30">
                <summary className="font-semibold text-gray-900 cursor-pointer list-none flex items-center justify-between">
                  How do I reset my password?
                  <span className="text-gray-400 group-open:rotate-180 transition-transform">↓</span>
                </summary>
                <p className="mt-3 text-gray-600 text-sm leading-relaxed">
                  On the login page, click "Forgot password?" and follow the instructions sent to
                  your registered email address.
                </p>
              </details>

              <details className="group border border-gray-100 rounded-2xl p-5 open:bg-blue-50/30">
                <summary className="font-semibold text-gray-900 cursor-pointer list-none flex items-center justify-between">
                  Is the mobile app available?
                  <span className="text-gray-400 group-open:rotate-180 transition-transform">↓</span>
                </summary>
                <p className="mt-3 text-gray-600 text-sm leading-relaxed">
                  Yes, Vkonekte is available on the App Store. Search for "Vkonekte" to download it.
                </p>
              </details>
            </div>
          </div>
        </section>

        <hr className="border-gray-200 mb-16" />

        {/* Russian */}
        <section>
          <h1 className="text-4xl font-extrabold text-gray-900 mb-2">Поддержка</h1>
          <p className="text-lg text-gray-500 mb-12">
            Мы готовы помочь. Свяжитесь с нами любым удобным способом.
          </p>

          <div className="grid gap-6 sm:grid-cols-2 mb-12">
            <div className="flex flex-col items-start gap-3 p-6 rounded-2xl border border-gray-100 bg-gray-50">
              <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-blue-100">
                <EnvelopeIcon className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <p className="font-semibold text-gray-900">Email</p>
                <a href="mailto:vkonekte.official@gmail.com" className="text-sm text-blue-600 hover:underline">
                  vkonekte.official@gmail.com
                </a>
              </div>
            </div>

            <div className="flex flex-col items-start gap-3 p-6 rounded-2xl border border-gray-100 bg-gray-50">
              <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-blue-100">
                <QuestionMarkCircleIcon className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <p className="font-semibold text-gray-900">Время ответа</p>
                <p className="text-sm text-gray-500">В течение 24 часов</p>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <h2 className="text-2xl font-bold text-gray-900">Часто задаваемые вопросы</h2>

            <div className="space-y-4">
              <details className="group border border-gray-100 rounded-2xl p-5 open:bg-blue-50/30">
                <summary className="font-semibold text-gray-900 cursor-pointer list-none flex items-center justify-between">
                  Как получить доступ к купленным курсам?
                  <span className="text-gray-400 group-open:rotate-180 transition-transform">↓</span>
                </summary>
                <p className="mt-3 text-gray-600 text-sm leading-relaxed">
                  После покупки войдите в аккаунт и перейдите в раздел «Мои курсы». Все приобретённые
                  курсы отобразятся там автоматически.
                </p>
              </details>

              <details className="group border border-gray-100 rounded-2xl p-5 open:bg-blue-50/30">
                <summary className="font-semibold text-gray-900 cursor-pointer list-none flex items-center justify-between">
                  Можно ли вернуть деньги?
                  <span className="text-gray-400 group-open:rotate-180 transition-transform">↓</span>
                </summary>
                <p className="mt-3 text-gray-600 text-sm leading-relaxed">
                  Возврат возможен в течение 7 дней с момента покупки, если контент курса не был
                  просмотрен. Напишите на vkonekte.official@gmail.com с деталями заказа.
                </p>
              </details>

              <details className="group border border-gray-100 rounded-2xl p-5 open:bg-blue-50/30">
                <summary className="font-semibold text-gray-900 cursor-pointer list-none flex items-center justify-between">
                  Как сбросить пароль?
                  <span className="text-gray-400 group-open:rotate-180 transition-transform">↓</span>
                </summary>
                <p className="mt-3 text-gray-600 text-sm leading-relaxed">
                  На странице входа нажмите «Забыли пароль?» и следуйте инструкциям, отправленным
                  на ваш электронный адрес.
                </p>
              </details>

              <details className="group border border-gray-100 rounded-2xl p-5 open:bg-blue-50/30">
                <summary className="font-semibold text-gray-900 cursor-pointer list-none flex items-center justify-between">
                  Есть ли мобильное приложение?
                  <span className="text-gray-400 group-open:rotate-180 transition-transform">↓</span>
                </summary>
                <p className="mt-3 text-gray-600 text-sm leading-relaxed">
                  Да, приложение Vkonekte доступно в App Store. Найдите «Vkonekte» и установите его.
                </p>
              </details>
            </div>
          </div>
        </section>
      </main>

      <footer className="border-t border-gray-100 mt-16 py-8 text-center text-sm text-gray-400">
        © {new Date().getFullYear()} Vkonekte. All rights reserved.
      </footer>
    </div>
  )
}
